import React from "react";
import { FormattedMessage } from "react-intl";
import { Checkbox } from "../../../../components/checkbox/Checkbox";

export const CheckboxElement = ({
  id,
  onChange,
  isChecked,
  title,
  description,
  ...attrs
}) => (
  <div className="form-checkbox">
    <Checkbox
      {...attrs}
      id={id}
      onChange={onChange}
      checked={!!isChecked}
      label={<FormattedMessage id={title} />}
      {...(description && { "aria-describedby": `${id}-description` })}
    />
    {description && (
      <div id={`${id}-description`} className="form-checkbox__description">
        <FormattedMessage id={description} />
      </div>
    )}
  </div>
);
